import Parse from 'url-parse'
import { getAPIendpointPrefix } from '../actions/apiHelper'
import getConfigValues, { insertInstanaScript, insertPendoScript, initPendo, insertArroyoScript } from '../../shared/configs/configuration'
import configFromParams from '../../client/lib/params'

import fetch from 'isomorphic-fetch'

const curUrl = new Parse(window.location.href, null, true)
const enableMacmillan = (curUrl.query && curUrl.query.user_id && curUrl.query.itemid) !== undefined
const view = curUrl.query.view !== undefined ? curUrl.query.view : 'student'

// this is to let fq tools launch a quiz
const isFqToolReferred = curUrl.query.isfqtoolreferred !== undefined ? curUrl.query.isfqtoolreferred : 'dontshow'

const config = configFromParams()

const checkToken = new Promise(function (resolve, reject) {
  callFetchApi(getAPIendpointPrefix() + 'api/v1/ptp/validateToken.php',
    {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({
        token: getCookie('id_token'),
        view,
        resourceId: curUrl.query.itemid,
        initial_check: true,
        fq_tool: isFqToolReferred
      })
    }).catch((exception) => {
    try {
      const jsonE = JSON.parse(exception)
      if (jsonE.badToken === true) {
        alert('Please login to your course before launching this application.' +
            '  If you continue to have issues, contact technical support.')
        reject(jsonE)
      } else { // it's OK if the URL doesn't respond or anything else happens
        resolve(true)
      }
    } catch (e) { // if it's not a JSON response then we're not interested
      resolve(true)
    }
    reject(false)
  }).then((response) => {
    if (response == null || response === 'false') {
      reject(false)
    } else {
      response = JSON.parse(response)
      resolve(response)
    }
  })
})

const loadUser = new Promise(function (resolve, reject) {
  if (enableMacmillan === true) {
    console.log('Macmillan ID enabled')

    checkToken.catch(function (exception) {
      console.error('Token Error')
      console.error(exception.error)
      throw exception
    }).then(function (checkTokenRes) {
      if (checkTokenRes === false) {
        console.error('Token Error')
      }
      const settingsTemplateId = curUrl.query.settingsTemplateId || ''
      const params = 'assignment_id=' + curUrl.query.itemid + '&settings_template_id=' + settingsTemplateId
      callFetchApi(getAPIendpointPrefix() + 'api/v1/assignment.php?' + params).then(
        function (response) {
          if (response.length === 0) {
            resolve(false)
          }

          response = JSON.parse(response)
          const currentUrl = window.location.href;
          const lc_origin = /bfwpub|int-hs-achieve/.test(currentUrl) ? 'HS' : 'HE';
          resolve({
            user_id: curUrl.query.user_id,
            macmillan_user_id: true,
            assignment_id: curUrl.query.itemid,
            user_rights: '1_student',
            isAdmin: checkTokenRes.admin,
            assignment_settings: response.assignment_settings !== undefined
              ? JSON.parse(response.assignment_settings)
              : '',
            lc_origin: lc_origin
          })
        })
    })
  } else {
    checkToken.catch(function (exception) {
      console.error('Token Error')
      console.error(exception.error)
      throw exception
    }).then((res) => {
      if (res === false) {
        reject(false)
      } else {
        resolve(true)
      }
    })
  }
})
/* end remote */

// middleware
export const MACMILLAN_API = Symbol('Macmillan API')
export default store => next => async action => {
  const macmillanApiConfig = action[MACMILLAN_API]
  if (typeof macmillanApiConfig === 'undefined') {
    return next(action)
  }

  const {
    types
  } = macmillanApiConfig

  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected an array of three action types.')
  }

  if (!types.every(type => typeof type === 'string')) {
    throw new Error('Expected action types to be strings.')
  }

  function actionWith (data) {
    const finalAction = { ...action, ...data }
    delete finalAction[MACMILLAN_API]
    return finalAction
  }

  const [
    requestType,
    successType,
    failureType
  ] = types

  // moves the chains of the action flow control

  // queue request action
  next(actionWith({ type: requestType }))

  try {
    const response = await loadUser
    const config = await getConfigValues()

    // dynamically inject Instana script in <head>
    insertInstanaScript(config.INSTANA_KEY)

    // conditionally enable and initialize pendo
    const pendoEnabled = config.FF_PENDO_ENABLED && config.FF_PENDO_ENABLED === 'true'
    if (pendoEnabled && config.isAchieve === true) {
      insertPendoScript(config.PENDO_APP_ID)
      initPendo(response.user_id, response.lc_origin)
    }

    // conditionally enable and initialize arroyo
    const arroyoEnabled = config.FF_ARROYO_ENABLED && config.FF_ARROYO_ENABLED === 'true'
    if (arroyoEnabled && config.isAchieve === true) {
      insertArroyoScript(config.ARROYO_URL)
    }

    next(actionWith({
      type: successType,
      response,
      config
    }))
  } catch (err) {
    console.log('err here', err)
    next(actionWith({
      type: failureType,
      error: err.message || 'Error in macmillan API'
    }))
  }
}

export function getCookie (name) {
  // LST-621: The cookie name will either be at the very beginning of the cookie string, or delimited with a preceding space character
  // So prepend `'(^| )'` to `name` to make sure we don't incorrectly choose a different cookie that
  // happens to end with the same substring as `name` (e.g. admin_id_token instead of just `id_token`)
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  if (match) {
    return match[2]
  } else {
    return false
  }
}

function callFetchApi (endpoint, opt = {}) {
  return fetch(endpoint, opt)
    .then(res => res.text().then(text => ({ text, res })))
    .then(({ text, res }) => res.ok ? text : Promise.reject(text))
}
// end middleware
